
const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      title: "Discovery & Assessment",
      description: "We analyze your current business, products, and goals to create a customized expansion roadmap.",
      duration: "Week 1-2"
    },
    {
      number: "02",
      title: "Market Research & Strategy",
      description: "Deep dive into target markets, competition analysis, and regulatory requirements for your specific industry.",
      duration: "Week 2-3"
    },
    {
      number: "03",
      title: "Technical Implementation",
      description: "Set up international payment systems, shipping solutions, and platform optimizations for global sales.",
      duration: "Week 3-6"
    },
    {
      number: "04",
      title: "Launch & Optimization",
      description: "Go live in new markets with ongoing monitoring, optimization, and performance tracking.",
      duration: "Week 6+"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Proven 4-Step Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From initial consultation to successful international launch, 
            we guide you through every step of the expansion process.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-teal-200"></div>
          
          <div className="grid lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step Number Circle */}
                <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center text-xl font-bold mb-6 mx-auto lg:mx-0 relative z-10">
                  {step.number}
                </div>
                
                <div className="text-center lg:text-left">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{step.description}</p>
                  <div className="inline-flex items-center text-sm text-teal-600 font-medium">
                    <i className="ri-time-line mr-2"></i>
                    {step.duration}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Start Your Global Journey Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
